<template>
  <div class="invoice-list">
    <div class="list-header">
      <h3 class="list-title">Счета по заказу</h3>
      <div class="header-actions">
        <base-button
          class="header-btn"
          @click="$router.push({ name: 'Templates' })"
        >
          Настройки шаблонов
        </base-button>

        <base-primary-button
          icon="addSquare"
          v-if="!isCreating"
          @click="startCreating"
        >
          Создать счёт
        </base-primary-button>
      </div>
    </div>

    <base-loader v-if="isLoading && !invoices.length" />

    <div v-else class="list-content">
      <OrderInvoiceForm
        v-if="isCreating"
        :order-id="orderId"
        :company-id="companyId"
        :is-create-mode="true"
        @save="handleCreateSuccess"
        @cancel="isCreating = false"
      />

      <div
        v-if="!isLoading && !invoices.length && !isCreating"
        class="no-data"
      >
        <span>Счетов по заказу нет</span>
      </div>

      <div v-for="invoice in invoices" :key="invoice.id">
        <OrderInvoiceItem
          :invoice="invoice"
          :order-id="orderId"
          :company-id="companyId"
          @updated="loadInvoices"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useOrderInvoiceStore } from "@/stores/orderInvoiceStore";
import { useNotificationStore } from "@/stores/notificationStore";

import OrderInvoiceItem from "./OrderInvoiceItem.vue";
import OrderInvoiceForm from "./OrderInvoiceForm.vue";

export default {
  name: "OrderInvoiceList",
  components: {
    OrderInvoiceItem,
    OrderInvoiceForm,
  },
  props: {
    orderId: { type: [String, Number], required: true },
    companyId: { type: [String, Number], required: true },
  },
  data() {
    return {
      isCreating: false,
    };
  },
  computed: {
    ...mapState(useOrderInvoiceStore, ["invoices", "isLoading"]),

    notificationStore() {
      return useNotificationStore();
    },
  },
  methods: {
    ...mapActions(useOrderInvoiceStore, ["getInvoicesRequest"]),

    async loadInvoices() {
      await this.getInvoicesRequest(this.orderId);
    },

    startCreating() {
      this.isCreating = true;
    },

    async handleCreateSuccess() {
      this.isCreating = false;
      await this.loadInvoices();
      this.notificationStore.showSuccess("Счёт успешно создан");
    },
  },
  async created() {
    await this.loadInvoices();
  },
};
</script>

<style scoped>
.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: var(--base-out-indent);
}

.list-title {
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 15px;
}

.list-content {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
  border: 1px dashed #e8e8e8;
  border-radius: 10px;
  background: #fafafa;
}
</style>
